(() => {
  // app/scripts/components/download-template.js
  var DownloadTemplate = class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.handleDownloadTemplate.bind(this));
    }
    handleDownloadTemplate() {
      if (!XLSX) {
        throw new Error("XLSX is not loaded");
      }
      const data = [
        ["SKU", "Qty"],
        ["example: xyz", "1"],
        ["example: ABC-DE123890", "1"],
        ["example: 123456", "1"]
      ];
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "import-example.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };
  customElements.define("download-template", DownloadTemplate);

  // app/scripts/components/init-tooltip.js
  var tooltipWrappers = document.querySelectorAll("[data-tooltip-wrapper]");
  tooltipWrappers.forEach((wrapper) => {
    const tooltip = wrapper.querySelector("[data-tooltip]");
    const toggleButtons = wrapper.querySelectorAll("[data-tooltip-toggle]");
    toggleButtons.forEach(
      (button) => button.addEventListener("click", () => {
        const isVisible = tooltip.classList.contains("is-shown");
        tooltip.classList.toggle("is-shown", !isVisible);
      })
    );
    if (window.innerWidth >= 768) {
      wrapper.addEventListener("mouseenter", () => {
        tooltip.classList.add("is-shown");
      });
      wrapper.addEventListener("mouseleave", () => {
        tooltip.classList.remove("is-shown");
      });
    }
  });

  // app/scripts/main-quick-order.js
  var MainQuickOrder = class extends HTMLElement {
    constructor() {
      super();
      this.selectedProducts = /* @__PURE__ */ new Set();
      this.productLists = /* @__PURE__ */ new Map();
      this.productSelector = this.querySelector("product-selector");
      this.productImporter = this.querySelector("product-importer");
      this.productListContainer = this.querySelector(".js-product-list");
      this.form = this.querySelector(".js-quick-order-form");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.submitBtn = this.querySelector('[name="add"]');
    }
    async connectedCallback() {
      await customElements.whenDefined("product-selector");
      this.productSelector.onAdd(this.handleProductAddedToSelection.bind(this));
      this.productImporter.onUpload(this.handleProductAddedToSelection.bind(this));
      this.listenSubmit();
      this.loadFromStorage();
    }
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
      if (!this.errorMsg)
        return;
      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = "";
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0)
            this.errorMsg.insertAdjacentHTML("beforeend", "<br>");
          this.errorMsg.insertAdjacentText("beforeend", err);
        });
      }
    }
    handleProductAddedToSelection(selectedItems) {
      console.log("selectedItems :>> ", selectedItems);
      this.mergeSelectedProducts(selectedItems);
      this.renderProducts();
      this.saveToStorage();
    }
    mergeSelectedProducts(products) {
      products.forEach((product) => {
        const id = `${product.variantId}`;
        const quantity = Number(product.quantity) || 1;
        const existing = this.productLists.get(id) || {};
        this.productLists.set(id, { ...existing, ...product, quantity });
      });
    }
    listenSubmit() {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }
    async handleSubmit(event) {
      event.preventDefault();
      this.setErrorMsgState(false);
      if (this.submitBtn.getAttribute("aria-disabled") === "true")
        return;
      const rows = this.productListContainer.querySelectorAll(".js-card-item");
      const items = [];
      rows.forEach((row) => {
        const idInput = row.querySelector('input[name*="[id]"]');
        const quantityInput = row.querySelector("quantity-input .qty-input__input");
        const id = Number(idInput?.value);
        const quantity = Math.max(0, Number(quantityInput?.value) || 0);
        if (id && quantity > 0) {
          items.push({ id, quantity });
        }
      });
      if (items.length === 0) {
        this.setErrorMsgState(theme.strings?.cart_empty_error || "Please select a quantity greater than 0");
        return;
      }
      this.submitBtn.setAttribute("aria-disabled", "true");
      this.submitBtn.classList.add("is-loading");
      const sections = ["cart-icon-bubble"];
      const cartDrawerSectionId = this.cartDrawer?.closest(".shopify-section")?.id?.replace("shopify-section-", "");
      if (cartDrawerSectionId)
        sections.push(cartDrawerSectionId);
      const payload = {
        items,
        sections: sections.join(","),
        sections_url: window.location.pathname
      };
      try {
        const response = await fetch(theme.routes?.cartAdd || `${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        const errorMessage = data.description || data.message;
        if (!response.ok || data.status) {
          this.setErrorMsgState(errorMessage || "Unable to add items to cart");
          throw new Error(errorMessage || response.status);
        }
        if (data.sections?.["cart-icon-bubble"]) {
          const cartIconBubble = document.getElementById("cart-icon-bubble");
          if (cartIconBubble) {
            cartIconBubble.innerHTML = data.sections["cart-icon-bubble"];
          }
        }
        if (theme.settings.afterAtc === "page") {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else if (this.cartDrawer) {
          this.cartDrawer.renderContents(data, theme.settings.afterAtc === "drawer");
        } else if (window.location.pathname === theme.routes.cart) {
          window.location.reload();
        }
      } catch (error) {
        this.setErrorMsgState(error?.message || "Unable to add items to cart");
        console.error(error);
      } finally {
        this.submitBtn.removeAttribute("aria-disabled");
        this.submitBtn.classList.remove("is-loading");
      }
    }
    async renderProducts() {
      try {
        const arr = [...this.productLists.values()];
        if (arr.length === 0) {
          this.productListContainer.innerHTML = "";
          this.checkEmpty();
          return;
        }
        const cardQuickOrderList = [];
        let hasPrunedInvalidItems = false;
        do {
          const chunk = arr.splice(0, 50);
          const variantSku = chunk.map(({ sku }) => sku);
          const chunkVariantIds = chunk.map(({ variantId }) => `${variantId}`);
          const response = await fetch(
            `${theme.routes.search}?view=card-quick-order&type=product&q=${variantSku.map((sku) => `variants.sku:${sku}`).join(" OR ")}`
          ).then((res) => res.text());
          const tbody = document.createElement("tbody");
          tbody.innerHTML = response;
          const newCards = tbody.querySelectorAll(".js-card-item");
          const returnedIds = [...newCards].map((card) => card.querySelector(".js-remove-item")?.dataset.variantId).filter(Boolean);
          chunkVariantIds.forEach((id) => {
            if (!returnedIds.includes(id)) {
              this.productLists.delete(id);
              hasPrunedInvalidItems = true;
            }
          });
          newCards.forEach(this.initCardItem.bind(this));
          cardQuickOrderList.push(...newCards);
        } while (arr.length > 0);
        this.productListContainer.innerHTML = "";
        this.productListContainer.append(...cardQuickOrderList);
        if (hasPrunedInvalidItems)
          this.saveToStorage();
        this.checkEmpty();
      } catch (error) {
        throw error;
      }
    }
    initCardItem(element) {
      const deleteButton = element.querySelector(".js-remove-item");
      const quantityInput = element.querySelector("quantity-input");
      const totalElm = element.querySelector(".js-total");
      const price = +element.dataset.price;
      const variantId = deleteButton.dataset.variantId;
      const quantityField = quantityInput?.querySelector(".qty-input__input");
      const fmtEnUS2 = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const updateTotalAndSave = () => {
        if (!quantityField)
          return;
        const qty = Math.max(0, Number(quantityField.value) || 0);
        const current = this.productLists.get(variantId) || {};
        this.productLists.set(variantId, { ...current, quantity: qty });
        this.saveToStorage();
        totalElm.textContent = theme.settings.moneyFormat.replace("{{amount}}", fmtEnUS2.format(price / 100 * qty));
      };
      const storedItem = this.productLists.get(variantId);
      if (storedItem?.quantity && quantityField) {
        quantityField.value = storedItem.quantity;
        quantityInput.currentQty = storedItem.quantity;
        updateTotalAndSave();
      }
      deleteButton.addEventListener("click", this.handleDeleteItem.bind(this));
      quantityInput.addEventListener("change", updateTotalAndSave);
    }
    saveToStorage() {
      const items = [...this.productLists.values()];
      localStorage.setItem("quick-order-items", JSON.stringify(items));
    }
    loadFromStorage() {
      try {
        const raw = localStorage.getItem("quick-order-items");
        if (!raw)
          return;
        const items = JSON.parse(raw);
        if (!Array.isArray(items)) {
          localStorage.removeItem("quick-order-items");
          return;
        }
        this.mergeSelectedProducts(items);
        this.renderProducts();
      } catch (error) {
        console.error("Quick order: failed to parse storage", error);
        localStorage.removeItem("quick-order-items");
      }
    }
    async handleDeleteItem(event) {
      const { target } = event;
      const { variantId } = target.dataset;
      this.productLists.delete(variantId);
      this.saveToStorage();
      target.closest(".js-card-item").remove();
      this.checkEmpty();
    }
    checkEmpty() {
      this.classList.toggle("is-empty", this.productLists.size === 0);
    }
  };
  if (!customElements.get("main-quick-order")) {
    customElements.define("main-quick-order", MainQuickOrder);
  }
})();
